import { useState } from 'react';
import { clearStoredPlayerAssignment, readStoredPlayerAssignment, writeStoredPlayerAssignment } from '../services/playerSessionStorage';

export function usePlayerAssignment() {
  const [assignment, setAssignmentState] = useState(readStoredPlayerAssignment());

  const setAssignment = (nextAssignment) => {
    writeStoredPlayerAssignment(nextAssignment);
    setAssignmentState(nextAssignment);
  };

  const clearAssignment = () => {
    clearStoredPlayerAssignment();
    setAssignmentState(null);
  };

  return { assignment, setAssignment, clearAssignment };
}
